import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { RestService } from '../../rest.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
import { setting } from '../../../../../setting';
import { Subject } from 'rxjs';

@Component({
  selector: 'usb-seller-select-modal',
  templateUrl: './seller-select-modal.component.html',
  styleUrls: ['./seller-select-modal.component.scss']
})
export class SellerSelectModalComponent implements OnInit {
  public title: string = '';
  public subtitle: string = '';
  public message: string = '';
  public showCancelButton: boolean = true;
  public confirmText: string = 'Si';
  public cancelText: string = 'No';
  public size: 'sm' | 'lg' | 'xl' = 'lg';
  public icon: string = '';
  public titleReverse: boolean = false;

  public agencies: any[] = [];
  public agencyImagenDynamic: string = 'assets/img/sin-logo.png';
  public clientSetting: any;
  public routeStorage: string = setting.apiStorageBooking;
  public comparisonRouteImagenLogo: string = setting.apiStorageBooking;
  public buttonColorActive: string = '';
  public buttonTextActive: string = '';

  _formSelectAgency: FormGroup;
  confirmResult: Subject<any> = new Subject<any>();

  constructor(
    public bsModalRef: BsModalRef,
    private restService: RestService,
    private formBuilder: FormBuilder,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.clientSetting = JSON.parse(localStorage.getItem(setting.name));
    const bookingFlow_sidebar = JSON.parse(this.clientSetting?.clients_setting_app_booking?.bookingFlow_sidebar);
    this.buttonColorActive = bookingFlow_sidebar?.background_color_header;
    this.buttonTextActive = bookingFlow_sidebar?.color;
    this.initForm();
    this.getAgencyAll();
    this.agencyImagenDynamic = 'assets/img/sin-logo.png';
  }

  initForm(): void {
    this._formSelectAgency = this.formBuilder.group({
      agencyId: new FormControl(null, Validators.required)
    });
  }

  onConfirm(): void {
    if (this._formSelectAgency.valid) {
      this.confirmResult.next({ success: true, agencyId: this._formSelectAgency.get('agencyId').value });
      this.bsModalRef.hide();
    } else {
      this.toastr.info('Seleccione una agencia');
    }
  }

  onDecline(): void {
    this.confirmResult.next(false);
    this.bsModalRef.hide();
  }

  confirmAction(): void {
    this.onConfirm();
  }

  declineAction(): void {
    this.onDecline();
  }

  onOverlayClick(event: Event): void {
    // Do nothing - overlay click doesn't close modal
  }

  confirm(): void {
    if (this._formSelectAgency.valid) {
      this.confirmResult.next({ success: true, agencyId: this._formSelectAgency.get('agencyId').value });
      this.bsModalRef.hide();
    } else {
      this.toastr.info('Seleccione una agencia');
    }
  }

  decline(): void {
    this.confirmResult.next(false);
    this.bsModalRef.hide();
  }

  getAgencyAll(): void {
    this.restService.doGet('app', 'allAgencies').subscribe({
      next: (res: any) => {
        if (res && res?.data) {
          res.data.forEach((agency: any) => {
            if (agency?.imagen_logotype) {
              agency.imagen_logotype = `${this.routeStorage}${agency.imagen_logotype}`;
            }
          });

          this.agencies = res.data;
          this.agencies = this.agencies.filter(c => c.currency !== null && c.id_agency_external === null);

          this.agencies.sort((a: any, b: any) => {
            const nameA = a.name || '';
            const nameB = b.name || '';
            return nameA.localeCompare(nameB);
          });
        }
      },
      error: (error: HttpErrorResponse) => {
        console.error('Error fetching agencies:', error);
      }
    });
  }

  changeAgency(id: number): void {
    if (!id) {
      return;
    }

    const agency = this.agencies?.find(c => Number(c.id) === Number(id));

    this.agencyImagenDynamic = agency?.imagen_logotype ?
                               agency?.imagen_logotype :
                               'assets/img/sin-logo.png';
  }

  get agencyImagen(): string {
    let agencyImagen = this.agencyImagenDynamic;
    if (agencyImagen === this.comparisonRouteImagenLogo || agencyImagen === '') {
        return 'assets/img/sin-logo.png';
    } else {
        return agencyImagen;
    }
  }

  get getClientsSettingAppBooking(): any {
    return this.clientSetting;
  }
}
